import { useBrand } from "../lib/brand";

// Build-time brand check. CRA's DefinePlugin inlines this; Terser DCEs the
// unreachable copy block so the cierge bundle never contains the RBT footer
// strings, and the RBT bundle never contains the cierge ones.
const COPY = process.env.REACT_APP_BRAND_MODE === "cierge"
    ? {
        col1Title: "Cierge Labs",
        col1Body:
            "A generic Cierge Labs demonstrator for responsible technology and AI governance. Designed to be reusable across leadership cohorts, responsible technology forums and technology governance boards.",
        col3Title: "This Demonstrator",
        col3Body:
            "All data shown is synthetic. No raw private data is processed. Public-safe receipt views never expose tokens, signed envelopes or partner-specific material.",
        tagline: "Custody · Authority · Receipts",
    }
    : {
        col1Title: "Right Brain Thinking International",
        col1Body:
            "Executive education and transformation partner. We educate leaders to build responsible, cybersecure and sustainable technology ecosystems.",
        col3Title: "This Sandbox",
        col3Body:
            "A rehearsal environment. All scenario data is synthetic. No real personal or customer data is processed by this lab. Receipts are cryptographically signed via the configured KATLAS node.",
        tagline: "Responsible · Cybersecure · Sustainable",
    };

export default function Footer() {
    const brand = useBrand();
    return (
        <footer
            className="border-t border-slate-200 mt-24 bg-white"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-slate-600">
                <div>
                    <div className="overline mb-3">{COPY.col1Title}</div>
                    <p className="leading-relaxed">{COPY.col1Body}</p>
                </div>
                <div>
                    <div className="overline mb-3">KATLAS</div>
                    <p className="leading-relaxed">
                        Live operational governance substrate. Custody, Authority,
                        Receipts. KATLAS proves what happened, who had authority and what
                        evidence was — and was not — shared.
                    </p>
                </div>
                <div>
                    <div className="overline mb-3">{COPY.col3Title}</div>
                    <p className="leading-relaxed">{COPY.col3Body}</p>
                </div>
            </div>
            <div className="border-t border-slate-200">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between text-xs text-slate-500">
                    <span>© {brand.footer_owner}</span>
                    <span className="font-mono tracking-tight">{COPY.tagline}</span>
                </div>
            </div>
        </footer>
    );
}
